/**
 * Main store function
 */
import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import { createLogger } from "redux-logger";
import rootReducer from "./reducers";
import DevTools from "../system/utils/DevTools";
import { loadingBarMiddleware } from "react-redux-loading-bar";
import logger from 'redux-logger'

export default function(initialState = {}) {
  // Middleware and store enhancers
  const enhancers = [
    applyMiddleware(
      thunk,
      logger,
      loadingBarMiddleware({
        promiseTypeSuffixes: ["START", "SUCCESS", "ERROR"]
      })
    )
  ];

  if (process.env.NODE_ENV !== "production") {
    enhancers.push(applyMiddleware(createLogger()));
    enhancers.push(
      window.devToolsExtension
        ? window.devToolsExtension() &&
          window.__REDUX_DEVTOOLS_EXTENSION__ &&
          window.__REDUX_DEVTOOLS_EXTENSION__()
        : DevTools.instrument()
    );
  }

  const store = createStore(rootReducer, initialState, compose(...enhancers));

  // For hot reloading reducers
  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept("./reducers", () => {
      const nextReducer = require("./reducers").default; // eslint-disable-line global-require
      store.replaceReducer(nextReducer);
    });
  }

  return store;
}



// WEBPACK FOOTER //
// ./src/store/config.js